const version = {
  develop: "1.19.6",
  validation: "1.19.6",
  pentest: "1.19.6",  
  preprod: "1.19.6",
  sit: "1.19.6",
  prod: "1.19.6",
  prodgreen: "1.19.6",
}
const environments = {
  develop: {
    REACT_APP_BACKEND_API_URL:
      "https://appser-mg-emb-ws-dev.azurewebsites.net/emb",
    REACT_APP_VERSION: version.develop,
    REACT_APP_AUTH_DOMAIN: "se-prosumer.auth0.com",
    REACT_APP_AUTH_CLIENTID: "qE7VguRSBsd6K30bjhUhN2QGrE0bmLcw",
    REACT_APP_AUTH_CALLBACKPATH: "/callback",
    REACT_APP_AUTH_SCOPE: "openid profile email frontend:read frontend:write",
    SKIP_PREFLIGHT_CHECK: true,
    FAST_REFRESH: false,
    WEBSITE_NODE_DEFAULT_VERSION: "18.17.0",
    WEBSITE_ENABLE_SYNC_UPDATE_SITE: false,
    WEBSITE_RUN_FROM_PACKAGE: 0,
    REACT_APP_ENABLED_ON_LOGIC:["MGaaS ETO","MGaaS ANSI","DaaS ETO","DaaS ANSI","NMGaaS ETO"],
    REACT_APP_ENABLED_OFF_GRID_PROJECT_TYPES:["MGaaS ETO","NMGaaS ETO"],
    REACT_APP_CLOSED_TRANSITION_CONFIG: {
      "MGaaS ETO": ["NO_FUEL", "FUEL_ERASER", "FUEL_SAVER"],
      "NMGaaS ETO": ["NO_FUEL", "FUEL_ERASER", "FUEL_SAVER","GENSET_MAIN_NO_BESS"],
      "MGaaS IEC": ["NO_FUEL", "FUEL_ERASER", "FUEL_SAVER"],
      "MGaaS ANSI": ["NO_FUEL", "FUEL_ERASER", "FUEL_SAVER"]
    }

  },
  validation: {
    REACT_APP_BACKEND_API_URL:
      "https://appser-mg-emb-ws-val.azurewebsites.net/emb/",
    REACT_APP_VERSION: version.validation,
    REACT_APP_AUTH_DOMAIN: "se-prosumer.auth0.com",
    REACT_APP_AUTH_CLIENTID: "iMtDwQAFbvuUHynXZZ21I12Jl2NaTWrh",
    REACT_APP_AUTH_CALLBACKPATH: "/callback",
    REACT_APP_AUTH_SCOPE: "openid profile email frontend:read frontend:write",
    REACT_APP_R_D: "Internal R&D use only.",
    REACT_APP_ALARM_SETTINGS: true,
    SKIP_PREFLIGHT_CHECK: true,
    FAST_REFRESH: false,
    WEBSITE_NODE_DEFAULT_VERSION: "18.17.0",
    WEBSITE_ENABLE_SYNC_UPDATE_SITE: false,
    WEBSITE_RUN_FROM_PACKAGE: 0,
  REACT_APP_ENABLED_ON_LOGIC:["MGaaS ETO","MGaaS ANSI","DaaS ETO","DaaS ANSI","NMGaaS ETO"],
    REACT_APP_ENABLED_OFF_GRID_PROJECT_TYPES:["MGaaS ETO","NMGaaS ETO"],
    REACT_APP_CLOSED_TRANSITION_CONFIG: {
      "MGaaS ETO": ["NO_FUEL", "FUEL_ERASER", "FUEL_SAVER"],
      "MGaaS IEC": ["NO_FUEL", "FUEL_ERASER", "FUEL_SAVER"],
      "MGaaS ANSI": ["NO_FUEL", "FUEL_ERASER", "FUEL_SAVER"]
    }
  },
  pentest: {
    REACT_APP_BACKEND_API_URL:
      "https://appser-mg-emb-ws-cto-sit.azurewebsites.net/emb/",
    REACT_APP_VERSION: "1.18.4",
    REACT_APP_AUTH_DOMAIN: "se-prosumer.auth0.com",
    REACT_APP_AUTH_CLIENTID: "vXN61r3PWSm4QkE6hw3y9Kq4enV7Akjn",
    REACT_APP_AUTH_CALLBACKPATH: "/callback",
    REACT_APP_AUTH_SCOPE: "openid profile email frontend:read frontend:write",
    SKIP_PREFLIGHT_CHECK: true,
    FAST_REFRESH: false,
    WEBSITE_NODE_DEFAULT_VERSION: "18.17.0",
    WEBSITE_ENABLE_SYNC_UPDATE_SITE: false,
    WEBSITE_RUN_FROM_PACKAGE: 0,
    REACT_APP_ENABLED_ON_LOGIC:["MGaaS ETO","MGaaS ANSI","DaaS ETO","DaaS ANSI","NMGaaS ETO"],
     REACT_APP_ENABLED_OFF_GRID_PROJECT_TYPES:["MGaaS ETO","NMGaaS ETO"],
     REACT_APP_CLOSED_TRANSITION_CONFIG: {
       "MGaaS ETO": ["NO_FUEL", "FUEL_ERASER", "FUEL_SAVER"],
       "MGaaS IEC": ["NO_FUEL", "FUEL_ERASER", "FUEL_SAVER"],
      "MGaaS ANSI": ["NO_FUEL", "FUEL_ERASER", "FUEL_SAVER"]
     }
  },
  preprodblue: {
    REACT_APP_BACKEND_API_URL:
      "https://appser-mg-emb-ws-cto-pprd-blue.azurewebsites.net/emb/",
    REACT_APP_VERSION: "1.18.5",
    REACT_APP_AUTH_DOMAIN: "se-prosumer.auth0.com",
    REACT_APP_AUTH_CLIENTID: "c5VWabH16JKPKlHe02Vonzc1uIGapsiB",
    REACT_APP_AUTH_CALLBACKPATH: "/callback",
    REACT_APP_AUTH_SCOPE: "openid profile email frontend:read frontend:write",
    REACT_APP_ETO_MESSAGE:
      "The project type is only available for SE internal use, not authorized for usage by EcoExperts/3rd party.",
    SKIP_PREFLIGHT_CHECK: true,
    FAST_REFRESH: false,
    WEBSITE_NODE_DEFAULT_VERSION: "18.17.0",
    WEBSITE_ENABLE_SYNC_UPDATE_SITE: false,
    WEBSITE_RUN_FROM_PACKAGE: 0,
    REACT_APP_ENABLED_ON_LOGIC:["MGaaS ETO","MGaaS ANSI","DaaS ETO","DaaS ANSI"],
  },
  preprod: {
    REACT_APP_BACKEND_API_URL:
      "https://appser-mg-emb-ws-cto-pprd.azurewebsites.net/emb/",
    REACT_APP_VERSION: version.preprod,
    REACT_APP_AUTH_DOMAIN: "se-prosumer.auth0.com",
    REACT_APP_AUTH_CLIENTID: "c5VWabH16JKPKlHe02Vonzc1uIGapsiB",
    REACT_APP_AUTH_CALLBACKPATH: "/callback",
    REACT_APP_AUTH_SCOPE: "openid profile email frontend:read frontend:write",
    REACT_APP_ETO_MESSAGE:
      "The project type is only available for SE internal use, not authorized for usage by EcoExperts/3rd party.",
    SKIP_PREFLIGHT_CHECK: true,
    FAST_REFRESH: false,
    WEBSITE_NODE_DEFAULT_VERSION: "18.17.0",
    WEBSITE_ENABLE_SYNC_UPDATE_SITE: false,
    WEBSITE_RUN_FROM_PACKAGE: 0,
    REACT_APP_ENABLED_ON_LOGIC:["MGaaS ETO","MGaaS ANSI","DaaS ETO","DaaS ANSI","NMGaaS ETO"],
     REACT_APP_ENABLED_OFF_GRID_PROJECT_TYPES:["MGaaS ETO","NMGaaS ETO"],
     REACT_APP_CLOSED_TRANSITION_CONFIG: {
       "MGaaS ETO": ["NO_FUEL", "FUEL_ERASER", "FUEL_SAVER"],
       "MGaaS IEC": ["NO_FUEL", "FUEL_ERASER", "FUEL_SAVER"],
      "MGaaS ANSI": ["NO_FUEL", "FUEL_ERASER", "FUEL_SAVER"]
     }
  },
  sit: {
    REACT_APP_BACKEND_API_URL:
      "https://systemintegration.ecostruxure-microgrid-build-standard.se.app/emb/",
    REACT_APP_VERSION: version.sit,
    REACT_APP_AUTH_DOMAIN: "se-prosumer.auth0.com",
    REACT_APP_AUTH_CLIENTID: "vXN61r3PWSm4QkE6hw3y9Kq4enV7Akjn",
    REACT_APP_AUTH_CALLBACKPATH: "/callback",
    REACT_APP_AUTH_SCOPE: "openid profile email frontend:read frontend:write",
    SKIP_PREFLIGHT_CHECK: true,
    FAST_REFRESH: false,
    WEBSITE_NODE_DEFAULT_VERSION: "18.17.0",
    WEBSITE_ENABLE_SYNC_UPDATE_SITE: false,
    WEBSITE_RUN_FROM_PACKAGE: 0,
     REACT_APP_ENABLED_OFF_GRID_PROJECT_TYPES:["MGaaS ETO","NMGaaS ETO"],
      REACT_APP_CLOSED_TRANSITION_CONFIG: {
       "MGaaS ETO": ["NO_FUEL", "FUEL_ERASER", "FUEL_SAVER"],
       "MGaaS IEC": ["NO_FUEL", "FUEL_ERASER", "FUEL_SAVER"],
      "MGaaS ANSI": ["NO_FUEL", "FUEL_ERASER", "FUEL_SAVER"]
     }
  },
  prod: {
    REACT_APP_BACKEND_API_URL:
      "https://ecostruxure-microgrid-build-standard.se.app/emb/",
    REACT_APP_VERSION: version.prod,
    REACT_APP_AUTH_DOMAIN: "se-prosumer.auth0.com",
    REACT_APP_AUTH_CLIENTID: "pikH84OfDGWz1ST6rbMsWYlmcpLQkKYA",
    REACT_APP_AUTH_CALLBACKPATH: "/callback",
    REACT_APP_AUTH_SCOPE: "openid profile email frontend:read frontend:write",
    REACT_APP_ETO_MESSAGE:
      "The project type is only available for SE internal use, not authorized for usage by EcoExperts/3rd party.",
    SKIP_PREFLIGHT_CHECK: true,
    FAST_REFRESH: false,
    WEBSITE_NODE_DEFAULT_VERSION: "18.17.0",
    WEBSITE_ENABLE_SYNC_UPDATE_SITE: false,
    WEBSITE_RUN_FROM_PACKAGE: 0,
    REACT_APP_ENABLED_ON_LOGIC:["MGaaS ETO","MGaaS ANSI","DaaS ETO","DaaS ANSI","NMGaaS ETO"],
     REACT_APP_ENABLED_OFF_GRID_PROJECT_TYPES:["MGaaS ETO","NMGaaS ETO"],
     REACT_APP_CLOSED_TRANSITION_CONFIG: {
       "MGaaS ETO": ["NO_FUEL", "FUEL_ERASER", "FUEL_SAVER"],
       "MGaaS IEC": ["NO_FUEL", "FUEL_ERASER", "FUEL_SAVER"],
      "MGaaS ANSI": ["NO_FUEL", "FUEL_ERASER", "FUEL_SAVER"]
     }
  },
   prodgreen: {
    REACT_APP_BACKEND_API_URL:
      "https://appser-mg-emb-cto-prod-green.azurewebsites.net/emb/",
    REACT_APP_VERSION: version.prodgreen,
    REACT_APP_AUTH_DOMAIN: "se-prosumer.auth0.com",
    REACT_APP_AUTH_CLIENTID: "pikH84OfDGWz1ST6rbMsWYlmcpLQkKYA",
    REACT_APP_AUTH_CALLBACKPATH: "/callback",
    REACT_APP_AUTH_SCOPE: "openid profile email frontend:read frontend:write",
    REACT_APP_ETO_MESSAGE:
      "The project type is only available for SE internal use, not authorized for usage by EcoExperts/3rd party.",
    SKIP_PREFLIGHT_CHECK: true,
    FAST_REFRESH: false,
    WEBSITE_NODE_DEFAULT_VERSION: "18.17.0",
    WEBSITE_ENABLE_SYNC_UPDATE_SITE: false,
    WEBSITE_RUN_FROM_PACKAGE: 0,
    REACT_APP_ENABLED_ON_LOGIC:["MGaaS ETO","MGaaS ANSI","DaaS ETO","DaaS ANSI","NMGaaS ETO"],
     REACT_APP_ENABLED_OFF_GRID_PROJECT_TYPES:["MGaaS ETO","NMGaaS ETO"],
     REACT_APP_CLOSED_TRANSITION_CONFIG: {
       "MGaaS ETO": ["NO_FUEL", "FUEL_ERASER", "FUEL_SAVER"],
       "MGaaS IEC": ["NO_FUEL", "FUEL_ERASER", "FUEL_SAVER"],
      "MGaaS ANSI": ["NO_FUEL", "FUEL_ERASER", "FUEL_SAVER"]
     }
  },
};
const hostname = window.location.hostname;
let env = environments.develop;

if (hostname.includes("develop") || hostname.includes("appser-mg-emb-se-dev")) {
  env = environments.develop;
} else if (
  hostname.includes("validation") ||
  hostname.includes("appser-mg-emb-val")
) {
  env = environments.validation;
} else if (
  hostname.includes("pentest") ||
  hostname.includes("appser-mg-emb-cto-sit") || hostname.includes("systemintegration")
) {
  env = environments.sit;
} else if (
  hostname.includes("preproduction") ||
  hostname.includes("preproduction.ecostruxure-microgrid-build-standard")
) {
  env = environments.preprod;
}else if (hostname.includes("appser-mg-emb-cto-pprd-blue-appser-mg-emb-cto-pprd.azurewebsites")) {
  env = environments.preprodblue;
}  else if (hostname.includes("ecostruxure-microgrid-build-standard")) {
  env = environments.prod;
}else if (hostname.includes("appser-mg-emb-se-cto-prod-green")) {
  env = environments.prodgreen;
}

export default env;
